export default __webpack_public_path__ + "static/media/bg-masthead-1-640w.64be1886.jpg";